// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xLXf","name":"styles_name__3sp4i","phone":"styles_phone__3Y8Uz"};